// extracted by mini-css-extract-plugin
export default {"header":"header_header__yXu8e","logo":"header_logo__ya4+O","logoImage":"header_logoImage__qS575","language":"header_language__1Y7e-","logout":"header_logout__SsCAY"};